(function () {
  const sectionSelector = '.elevate-occasion-hero.occasion-hero--clean';
  const mobileMQ = window.matchMedia('(max-width: 989px)');
  const reducedMotionMQ = window.matchMedia('(prefers-reduced-motion: reduce)');

  let items = [];
  let ticking = false;

  function collectSections() {
    items = Array.from(document.querySelectorAll(sectionSelector))
      .map((section) => ({
        section,
        image: section.querySelector('.occasion-hero__image-wrap img')
      }))
      .filter((item) => item.image);
  }

  function resetParallax() {
    items.forEach(({ section }) => {
      section.style.setProperty('--occasion-hero-parallax-y', '0px');
    });
  }

  function updateParallax() {
    ticking = false;

    if (!mobileMQ.matches || reducedMotionMQ.matches) {
      resetParallax();
      return;
    }

    const viewportHeight =
      window.innerHeight || document.documentElement.clientHeight;

    items.forEach(({ section }) => {
      const rect = section.getBoundingClientRect();

      if (rect.bottom < 0 || rect.top > viewportHeight) return;

      const progress =
        (viewportHeight - rect.top) / (viewportHeight + rect.height);

      /* a little more noticeable than before */
      const translateY = (progress - 0.5) * 64;
      const clamped = Math.max(-32, Math.min(32, translateY));

      section.style.setProperty(
        '--occasion-hero-parallax-y',
        clamped.toFixed(2) + 'px'
      );
    });
  }

  function requestTick() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(updateParallax);
    }
  }

  function initParallax() {
    collectSections();
    updateParallax();
  }

  document.addEventListener('DOMContentLoaded', initParallax);

  if (document.readyState !== 'loading') {
    initParallax();
  }

  window.addEventListener('scroll', requestTick, { passive: true });
  window.addEventListener('resize', requestTick);
  window.addEventListener('orientationchange', requestTick);

  document.addEventListener('shopify:section:load', initParallax);
  document.addEventListener('shopify:section:reorder', initParallax);
  document.addEventListener('shopify:section:select', requestTick);
})();